import { ComponentsOverrides, ComponentsProps, Theme } from '@mui/material';
import { COLOR_NEUTRAL_DARKEST, COLOR_NEUTRAL_MID, COLOR_PRIMARY, COLOR_WH } from 'shared/config';

export enum FontWeights {
  Light = 300,
  Regular = 400,
  Medium = 500,
  Bold = 700,
}

export const customVariations = {
  '&.bold': {
    fontWeight: FontWeights.Bold,
  },
};

export enum FontFamilies {
  primary = '"Inter", sans-serif',
  secondary = '"Roc Grotesk", sans-serif',
}

export const getTypographyOverrides = (theme: Theme): ComponentsOverrides['MuiTypography'] => ({
  root: {
    textTransform: 'none',
    color: theme.themeColors.mainColor,
    fontFamily: FontFamilies.primary,
    fontWeight: FontWeights.Regular,
    textAlign: 'left',
    fontStyle: 'normal',
    ...customVariations,
    '&.gray': {
      color: COLOR_NEUTRAL_MID,
    },
    '&.white': {
      color: COLOR_WH,
    },
    '&.dark': {
      color: COLOR_NEUTRAL_DARKEST,
    },
    '&.yellow': {
      color: COLOR_PRIMARY,
    },
  },

  h1: {
    fontSize: 64,
    lineHeight: '92px',
    fontFamily: FontFamilies.secondary,

    [theme.breakpoints.down('lg')]: {
      fontSize: 64,
      lineHeight: '92px',
    },

    [theme.breakpoints.down('md')]: {
      fontSize: 40,
      lineHeight: '56px',
    },
  },

  h2: {
    fontSize: 28,
    fontFamily: FontFamilies.secondary,
  },

  h3: {
    fontSize: 24,
    lineHeight: '56px',
    fontFamily: FontFamilies.secondary,
  },

  subtitle1: {
    fontSize: 16,
    lineHeight: '24px',
    fontWeight: FontWeights.Medium,
    fontFamily: FontFamilies.secondary,
  },

  body1: {
    fontSize: 16,
    lineHeight: '24px',
  },
  body2: {
    fontSize: 15,
    lineHeight: '24px',
    fontFamily: FontFamilies.primary,
    fontWeight: FontWeights.Regular,
  },

  subtitle2: {
    fontSize: 12,
    lineHeight: '22px',
  },

  button: {
    fontSize: 16,
    textTransform: 'none',
    fontFamily: FontFamilies.secondary,
    fontWeight: FontWeights.Bold,
  },
  caption: {
    fontSize: 14,
    lineHeight: '24px',
  },
});

export const getTypographyDefaultProps = (): ComponentsProps['MuiTypography'] => ({
  variant: 'body1',
});
